var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#2D2D2D",
    d: "M10.2 10L6.9 6.7l1.5-1.4 4.7 4.7-4.7 4.7-1.5-1.4z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBiYXNlUHJvZmlsZT0idGlueSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPg0KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiMyRDJEMkQiIGQ9Ik0xMC4yIDEwTDYuOSA2LjdsMS41LTEuNCA0LjcgNC43LTQuNyA0LjctMS41LTEuNHoiLz4NCjwvc3ZnPg0K";
export { SvgChevronRight as ReactComponent };